import FpuiTable from './FpuiTable'
import FpuiTableRow from './FpuiTableRow'
import FpuiTableHeader from './FpuiTableHeader'

import './FpuiTable.less'

export { FpuiTable, FpuiTableRow, FpuiTableHeader }
export default { FpuiTable, FpuiTableRow, FpuiTableHeader }
